import * as React from 'react';

import {cn} from '../lib/utils';
import {Button, ButtonProps} from './button';

export interface ButtonWithIndicatorProps extends ButtonProps {
  showIndicator?: boolean;
  indicatorClassName?: string;
}

const ButtonWithIndicator = React.forwardRef<
  HTMLButtonElement,
  ButtonWithIndicatorProps
>(({children, showIndicator, indicatorClassName, className, ...props}, ref) => {
  return (
    <Button {...props} className={cn('relative', className)} ref={ref}>
      {children}
      {showIndicator && (
        <span
          className={cn(
            'absolute -top-0.5 -right-0.5 h-2 w-2 rounded-full bg-tertiary',
            indicatorClassName,
          )}
          aria-hidden="true"
        />
      )}
    </Button>
  );
});
ButtonWithIndicator.displayName = 'ButtonWithIndicator';

export {ButtonWithIndicator};
